// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfileInfo-commonHeaderAdmin-pVfNZ {
	position: fixed !important;
}

.EditProfileInfo-adminLayout-Uftpd {
	padding-top: 64px !important;
}

.EditProfileInfo-box-a6ePH h2 {
	font-size: 21px;
	font-weight: 600;
}

.EditProfileInfo-exportLink-d0YxX {
	margin-bottom: -29px;
}

.EditProfileInfo-blockCenter-c69Gc {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.EditProfileInfo-panelHeader-ushvb {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.EditProfileInfo-currencyselect-E3Dvz {
	width: 100%;
	margin-right: 0px;
}

.EditProfileInfo-panelHeader-ushvb {
	overflow: hidden;
	position: relative;
}

.EditProfileInfo-mar0-F_A3H {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.EditProfileInfo-blockCenter-c69Gc {
		padding: 0px;
	}

	.EditProfileInfo-panelHeader-ushvb {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.EditProfileInfo-sideAdminPageWrapper-zLfUV {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.EditProfileInfo-panelHeader-ushvb {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.EditProfileInfo-table-iQJCy {
	display: table;
}

.EditProfileInfo-tableRow-uCl2X {
	display: table-row;
}

.EditProfileInfo-tableCell-pan9a {
	display: table-cell;
	float: none;
}

.EditProfileInfo-formGroup-a9MUQ {
	margin-bottom: 6px;
}

.EditProfileInfo-select-ch6jU {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.EditProfileInfo-noMargin-JYxYd {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.EditProfileInfo-exportLink-d0YxX {
	padding-top: 10px;
	padding-right: 10px;
}

.EditProfileInfo-labelTextNew-_6EkF {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditProfileInfo-displayInline-H39ia {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.EditProfileInfo-btnUPdate-GF7FF {
	display: inline-block;
}

.EditProfileInfo-btnModalDelete-htu9E {
	display: inline-block;
	margin-left: 15px;
}

.EditProfileInfo-radioBtn-zufpc {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.EditProfileInfo-backgroundImg-6_P4J {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.EditProfileInfo-btnUPdate-GF7FF {
		display: block;
		margin-bottom: 12px;
	}

	.EditProfileInfo-btnModalDelete-htu9E {
		display: block;
		margin-left: 0px;
	}

	.EditProfileInfo-btnWidth-A5cSB {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.EditProfileInfo-bannerImageBg-yOIjy {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.EditProfileInfo-bannerDelete-pxxLF {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.EditProfileInfo-modalRoot-XNdO9 {
	padding: 32px;
}

.EditProfileInfo-modalBorderBottom-_I6xX {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.EditProfileInfo-logInModalBody-ztQD1 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.EditProfileInfo-exportSection-BIjks {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.EditProfileInfo-exportSectionGridSub-Y6TLe {
	grid-template-columns: 50% 49% !important;
}

.EditProfileInfo-exportText-YiKzD {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.EditProfileInfo-exportLinkImg-JDtyM {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.EditProfileInfo-vtrMiddle-QO3J8 {
	vertical-align: middle;
}

.EditProfileInfo-exportImg-caqLn {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditProfileInfo-profileViewlabel-lz6SU {
	display: inline-block;
	width: 38%
}

.EditProfileInfo-profileViewMainContent-scRCm {
	display: inline-block;
	width: 62%;
}

.EditProfileInfo-profileViewMain-URM68 {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.EditProfileInfo-profileViewInner-Bs1Nq {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.EditProfileInfo-profileImageSection-zU0nY {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.EditProfileInfo-lastviewInner-c0zYA {
	padding: 10px;
}

.EditProfileInfo-whyHostHoriLine-mDdKF {
	margin: 30px 0;
}

.EditProfileInfo-tableGrid-GFK6d {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.EditProfileInfo-headingContent-uf1oG {
	font-size: 18px;
	font-weight: 500;
}

.EditProfileInfo-refundTextColor-YU3Vr {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.EditProfileInfo-dividerLine-BnvsM {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.EditProfileInfo-smallContent-CTpGo {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.EditProfileInfo-sideAdminPageWrapper-zLfUV {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.EditProfileInfo-sideAdminPageWrapper-zLfUV {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.EditProfileInfo-exportSection-BIjks {
		grid-template-columns: 100%;
	}

	.EditProfileInfo-exportSectionGridSub-Y6TLe {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.EditProfileInfo-profileViewlabel-lz6SU {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditProfileInfo-profileViewMainContent-scRCm {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.EditProfileInfo-ChangeToUpperCase-NyCzv {
	text-transform: uppercase
}

.EditProfileInfo-noBorder-fHuOc {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.EditProfileInfo-siteAdminHeading-TXZzS {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditProfileInfo-siteAdminSubHeading-EYxl2 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditProfileInfo-adminFormDivider-qPu33 {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.EditProfileInfo-space1-VIAIa {
	margin-bottom: 6px !important;
}

.EditProfileInfo-space2-D0vPD {
	margin-bottom: 12px !important;
}

.EditProfileInfo-space3-IdSJ3 {
	margin-bottom: 18px !important;
}

.EditProfileInfo-space4-ZxkBC {
	margin-bottom: 24px !important;
}

.EditProfileInfo-space5-WzYJ1 {
	margin-bottom: 30px !important;
}

.EditProfileInfo-space6-LqWFN {
	margin-bottom: 36px !important;
}

.EditProfileInfo-space7-zlDH0 {
	margin-bottom: 42px !important;
}

.EditProfileInfo-spaceTop8-fRNlv {
	margin-bottom: 48px !important;
}

.EditProfileInfo-spaceTop1-Tez8W {
	margin-top: 6px !important;
}

.EditProfileInfo-spaceTop2-nMCnn {
	margin-top: 12px !important;
}

.EditProfileInfo-spaceTop3-g_K6a {
	margin-top: 18px !important;
}

.EditProfileInfo-spaceTop4-inDjf {
	margin-top: 24px !important;
}

.EditProfileInfo-spaceTop5-Q1NXe {
	margin-top: 30px !important;
}

.EditProfileInfo-spaceTop6-XK_lg {
	margin-top: 36px !important;
}

.EditProfileInfo-spaceTop7-j4lDi {
	margin-top: 42px !important;
}

.EditProfileInfo-spaceTop8-fRNlv {
	margin-top: 48px !important;
}

.EditProfileInfo-noMargin-JYxYd {
	margin: 0px !important;
}

.EditProfileInfo-padding1-KaXnI {
	padding-bottom: 6px !important;
}

.EditProfileInfo-padding2-xOW93 {
	padding-bottom: 12px !important;
}

.EditProfileInfo-padding3-CyUTo {
	padding-bottom: 18px !important;
}

.EditProfileInfo-padding4-sDBPI {
	padding-bottom: 24px !important;
}

.EditProfileInfo-padding5-AFWIQ {
	padding-bottom: 30px !important;
}

.EditProfileInfo-padding6-wWlBQ {
	padding-bottom: 36px !important;
}

.EditProfileInfo-padding7-Tn3em {
	padding-bottom: 42px !important;
}

.EditProfileInfo-paddingTop1-eblDA {
	padding-top: 6px !important;
}

.EditProfileInfo-paddingTop2-m7bpz {
	padding-top: 12px !important;
}

.EditProfileInfo-paddingTop3-AGBPv {
	padding-top: 18px !important;
}

.EditProfileInfo-paddingTop4-HMSHe {
	padding-top: 24px !important;
}

.EditProfileInfo-paddingTop5-XtAZO {
	padding-top: 30px !important;
}

.EditProfileInfo-paddingTop6-HKEs3 {
	padding-top: 36px !important;
}

.EditProfileInfo-paddingTop7-yWbXp {
	padding-top: 42px !important;
}

.EditProfileInfo-noPadding-qIr2e {
	padding: 0px !important;
}

.EditProfileInfo-textBold-NqzGe {
	font-weight: 500 !important;
}

.EditProfileInfo-textBolder-QODDG {
	font-weight: 700 !important;
}

.EditProfileInfo-textNormal-w9QiL {
	font-weight: normal !important;
}

.EditProfileInfo-spaceBottom20-P4Yy_ {
	margin-bottom: 20px;
}

.EditProfileInfo-spaceBottom10-ddqCQ {
	margin-bottom: 10px;
}

.EditProfileInfo-marginNone-Jxru5 {
	margin: 0;
}

.EditProfileInfo-spaceBottom15-RGdju {
	margin-bottom: 15px;
}

.EditProfileInfo-marginTopNone-SeqjU {
	margin-top: 0;
}

.EditProfileInfo-spaceTop11-EYvFd {
	margin-top: 11px;
}

.EditProfileInfo-spaceTop21-x46vk {
	margin-top: 21px;
}

.EditProfileInfo-spaceTop20-x41zB {
	margin-top: 20px;
}

.EditProfileInfo-spaceTop10-sDx6n {
	margin-top: 10px;
}

/*New Design Text Colors */

.EditProfileInfo-textDarkBlue-TJoQV {
	color: rgb(20, 39, 94) !important;
}

.EditProfileInfo-textLightBlue-TxjIg {
	color: rgb(57, 87, 106) !important;
}

.EditProfileInfo-textLightSandleGreen-bExbx {
	color: rgb(76, 86, 41) !important;
}

.EditProfileInfo-textLightBrown-nUAZy {
	color: rgb(115, 79, 33) !important;
}

.EditProfileInfo-textMediumMaroon-g0cfl {
	color: rgb(87, 37, 51) !important;
}

.EditProfileInfo-textBrown-dPy23 {
	color: rgb(160, 47, 24) !important;
}

.EditProfileInfo-textMaroon-GXy4g {
	color: rgb(155, 49, 67) !important;
}

.EditProfileInfo-textDarkBrown-zjox7 {
	color: rgb(83, 18, 16) !important;
}

.EditProfileInfo-textMediumBrown-TJtpJ {
	color: rgb(142, 28, 10) !important;
}

.EditProfileInfo-textSkyBlue-LFZo9 {
	color: rgb(37, 117, 141) !important;
}

.EditProfileInfo-textGray-TaBcR {
	color: rgb(77, 65, 51) !important;
}

.EditProfileInfo-editProfileWrapper-I7Er_ {
    max-width: 950px;
    margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/EditProfileInfo/EditProfileInfo.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACzNA;IACI,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../../helpers.css';\n\n.editProfileWrapper {\n    max-width: 950px;\n    margin: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `EditProfileInfo-commonHeaderAdmin-pVfNZ`,
	"adminLayout": `EditProfileInfo-adminLayout-Uftpd`,
	"box": `EditProfileInfo-box-a6ePH`,
	"exportLink": `EditProfileInfo-exportLink-d0YxX`,
	"blockCenter": `EditProfileInfo-blockCenter-c69Gc`,
	"panelHeader": `EditProfileInfo-panelHeader-ushvb`,
	"currencyselect": `EditProfileInfo-currencyselect-E3Dvz`,
	"mar0": `EditProfileInfo-mar0-F_A3H`,
	"sideAdminPageWrapper": `EditProfileInfo-sideAdminPageWrapper-zLfUV`,
	"table": `EditProfileInfo-table-iQJCy`,
	"tableRow": `EditProfileInfo-tableRow-uCl2X`,
	"tableCell": `EditProfileInfo-tableCell-pan9a`,
	"formGroup": `EditProfileInfo-formGroup-a9MUQ`,
	"select": `EditProfileInfo-select-ch6jU`,
	"noMargin": `EditProfileInfo-noMargin-JYxYd`,
	"labelTextNew": `EditProfileInfo-labelTextNew-_6EkF`,
	"displayInline": `EditProfileInfo-displayInline-H39ia`,
	"btnUPdate": `EditProfileInfo-btnUPdate-GF7FF`,
	"btnModalDelete": `EditProfileInfo-btnModalDelete-htu9E`,
	"radioBtn": `EditProfileInfo-radioBtn-zufpc`,
	"backgroundImg": `EditProfileInfo-backgroundImg-6_P4J`,
	"btnWidth": `EditProfileInfo-btnWidth-A5cSB`,
	"bannerImageBg": `EditProfileInfo-bannerImageBg-yOIjy`,
	"bannerDelete": `EditProfileInfo-bannerDelete-pxxLF`,
	"modalRoot": `EditProfileInfo-modalRoot-XNdO9`,
	"modalBorderBottom": `EditProfileInfo-modalBorderBottom-_I6xX`,
	"logInModalBody": `EditProfileInfo-logInModalBody-ztQD1`,
	"exportSection": `EditProfileInfo-exportSection-BIjks`,
	"exportSectionGridSub": `EditProfileInfo-exportSectionGridSub-Y6TLe`,
	"exportText": `EditProfileInfo-exportText-YiKzD`,
	"exportLinkImg": `EditProfileInfo-exportLinkImg-JDtyM`,
	"vtrMiddle": `EditProfileInfo-vtrMiddle-QO3J8`,
	"exportImg": `EditProfileInfo-exportImg-caqLn`,
	"profileViewlabel": `EditProfileInfo-profileViewlabel-lz6SU`,
	"profileViewMainContent": `EditProfileInfo-profileViewMainContent-scRCm`,
	"profileViewMain": `EditProfileInfo-profileViewMain-URM68`,
	"profileViewInner": `EditProfileInfo-profileViewInner-Bs1Nq`,
	"profileImageSection": `EditProfileInfo-profileImageSection-zU0nY`,
	"lastviewInner": `EditProfileInfo-lastviewInner-c0zYA`,
	"whyHostHoriLine": `EditProfileInfo-whyHostHoriLine-mDdKF`,
	"tableGrid": `EditProfileInfo-tableGrid-GFK6d`,
	"headingContent": `EditProfileInfo-headingContent-uf1oG`,
	"refundTextColor": `EditProfileInfo-refundTextColor-YU3Vr`,
	"dividerLine": `EditProfileInfo-dividerLine-BnvsM`,
	"smallContent": `EditProfileInfo-smallContent-CTpGo`,
	"ChangeToUpperCase": `EditProfileInfo-ChangeToUpperCase-NyCzv`,
	"noBorder": `EditProfileInfo-noBorder-fHuOc`,
	"siteAdminHeading": `EditProfileInfo-siteAdminHeading-TXZzS`,
	"siteAdminSubHeading": `EditProfileInfo-siteAdminSubHeading-EYxl2`,
	"adminFormDivider": `EditProfileInfo-adminFormDivider-qPu33`,
	"space1": `EditProfileInfo-space1-VIAIa`,
	"space2": `EditProfileInfo-space2-D0vPD`,
	"space3": `EditProfileInfo-space3-IdSJ3`,
	"space4": `EditProfileInfo-space4-ZxkBC`,
	"space5": `EditProfileInfo-space5-WzYJ1`,
	"space6": `EditProfileInfo-space6-LqWFN`,
	"space7": `EditProfileInfo-space7-zlDH0`,
	"spaceTop8": `EditProfileInfo-spaceTop8-fRNlv`,
	"spaceTop1": `EditProfileInfo-spaceTop1-Tez8W`,
	"spaceTop2": `EditProfileInfo-spaceTop2-nMCnn`,
	"spaceTop3": `EditProfileInfo-spaceTop3-g_K6a`,
	"spaceTop4": `EditProfileInfo-spaceTop4-inDjf`,
	"spaceTop5": `EditProfileInfo-spaceTop5-Q1NXe`,
	"spaceTop6": `EditProfileInfo-spaceTop6-XK_lg`,
	"spaceTop7": `EditProfileInfo-spaceTop7-j4lDi`,
	"padding1": `EditProfileInfo-padding1-KaXnI`,
	"padding2": `EditProfileInfo-padding2-xOW93`,
	"padding3": `EditProfileInfo-padding3-CyUTo`,
	"padding4": `EditProfileInfo-padding4-sDBPI`,
	"padding5": `EditProfileInfo-padding5-AFWIQ`,
	"padding6": `EditProfileInfo-padding6-wWlBQ`,
	"padding7": `EditProfileInfo-padding7-Tn3em`,
	"paddingTop1": `EditProfileInfo-paddingTop1-eblDA`,
	"paddingTop2": `EditProfileInfo-paddingTop2-m7bpz`,
	"paddingTop3": `EditProfileInfo-paddingTop3-AGBPv`,
	"paddingTop4": `EditProfileInfo-paddingTop4-HMSHe`,
	"paddingTop5": `EditProfileInfo-paddingTop5-XtAZO`,
	"paddingTop6": `EditProfileInfo-paddingTop6-HKEs3`,
	"paddingTop7": `EditProfileInfo-paddingTop7-yWbXp`,
	"noPadding": `EditProfileInfo-noPadding-qIr2e`,
	"textBold": `EditProfileInfo-textBold-NqzGe`,
	"textBolder": `EditProfileInfo-textBolder-QODDG`,
	"textNormal": `EditProfileInfo-textNormal-w9QiL`,
	"spaceBottom20": `EditProfileInfo-spaceBottom20-P4Yy_`,
	"spaceBottom10": `EditProfileInfo-spaceBottom10-ddqCQ`,
	"marginNone": `EditProfileInfo-marginNone-Jxru5`,
	"spaceBottom15": `EditProfileInfo-spaceBottom15-RGdju`,
	"marginTopNone": `EditProfileInfo-marginTopNone-SeqjU`,
	"spaceTop11": `EditProfileInfo-spaceTop11-EYvFd`,
	"spaceTop21": `EditProfileInfo-spaceTop21-x46vk`,
	"spaceTop20": `EditProfileInfo-spaceTop20-x41zB`,
	"spaceTop10": `EditProfileInfo-spaceTop10-sDx6n`,
	"textDarkBlue": `EditProfileInfo-textDarkBlue-TJoQV`,
	"textLightBlue": `EditProfileInfo-textLightBlue-TxjIg`,
	"textLightSandleGreen": `EditProfileInfo-textLightSandleGreen-bExbx`,
	"textLightBrown": `EditProfileInfo-textLightBrown-nUAZy`,
	"textMediumMaroon": `EditProfileInfo-textMediumMaroon-g0cfl`,
	"textBrown": `EditProfileInfo-textBrown-dPy23`,
	"textMaroon": `EditProfileInfo-textMaroon-GXy4g`,
	"textDarkBrown": `EditProfileInfo-textDarkBrown-zjox7`,
	"textMediumBrown": `EditProfileInfo-textMediumBrown-TJtpJ`,
	"textSkyBlue": `EditProfileInfo-textSkyBlue-LFZo9`,
	"textGray": `EditProfileInfo-textGray-TaBcR`,
	"editProfileWrapper": `EditProfileInfo-editProfileWrapper-I7Er_`
};
module.exports = ___CSS_LOADER_EXPORT___;
